// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"218":"9aaf036d","257":"a246afe7"}[chunkId] + ".chunk.js";
};